import React from 'react';
import styles from './styles.css.js';
var ResizeHandler = React.createElement("span", { className: styles['resizable-box-handle'] });
export default ResizeHandler;
//# sourceMappingURL=resize-handler.js.map